import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-2 pb-2 text-left" }
const _hoisted_6 = { class: "text-sm" }
const _hoisted_7 = { class: "mt-1" }
const _hoisted_8 = { class: "mt-2 pb-2 text-left" }
const _hoisted_9 = { class: "text-sm" }
const _hoisted_10 = { class: "mt-1" }
const _hoisted_11 = { class: "mt-2 pb-2 text-left" }
const _hoisted_12 = { class: "text-sm" }
const _hoisted_13 = { class: "mt-1" }
const _hoisted_14 = { class: "mt-2 pb-2 text-left" }
const _hoisted_15 = { class: "text-sm" }
const _hoisted_16 = { class: "mt-1" }
const _hoisted_17 = { class: "mt-2 pb-2 text-left" }
const _hoisted_18 = { class: "text-sm" }
const _hoisted_19 = { class: "mt-1" }
const _hoisted_20 = { class: "mt-2 pb-2 text-left" }
const _hoisted_21 = { class: "text-sm" }
const _hoisted_22 = { class: "mt-1" }
const _hoisted_23 = { class: "mt-2 pb-2 text-left" }
const _hoisted_24 = { class: "text-sm" }
const _hoisted_25 = { class: "mt-1" }
const _hoisted_26 = { class: "mt-2 pb-2 text-left" }
const _hoisted_27 = { class: "text-sm" }
const _hoisted_28 = { class: "mt-1" }
const _hoisted_29 = { class: "mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense" }

import { computed, ref } from "vue";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
} from "@headlessui/vue";
import DropdownComponent from "../tools/DropdownComponent.vue";
import { translate } from "@/utils/tools";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityLogFilterDialog',
  props: { form: Object, show: Boolean },
  emits: ["submit", "update:show", "update:form"],
  setup(__props, { emit }) {

const props = __props

const actionList = ref([
  {
    label: "All",
    value: "",
  },
  {
    label: "Create New Player",
    value: "Create New Player",
  },
  {
    label: "Activate User",
    value: "Activate User",
  },
  {
    label: "Edit Bank Account",
    value: "Edit Bank Account",
  },
  {
    label: "Create Update Username Request",
    value: "Create Update Username Request",
  },
  {
    label: "Change Password",
    value: "Change Password",
  },
  {
    label: "Manual Topup Point Request",
    value: "Manual Topup Point Request",
  },
  {
    label: "Update Redeamtion Limit",
    value: "Update Redeamtion Limit",
  },
  {
    label: "Manual Deduct Point Request",
    value: "Manual Deduct Point Request",
  },
  {
    label: "Manual Deposit",
    value: "Manual Deposit",
  },
  {
    label: "Manual Withdraw",
    value: "Manual Withdraw",
  },
  {
    label: "Create Ticket",
    value: "Create Ticket",
  },
  {
    label: "Topup Cash",
    value: "Topup Cash",
  },
  {
    label: "Enable Affiliate Dashboard",
    value: "Enable Affiliate Dashboard",
  },
  {
    label: "Disable Affiliate Dashboard",
    value: "Disable Affiliate Dashboard",
  },
  {
    label: "Suspend User",
    value: "Suspend User",
  },
  {
    label: "Activate User",
    value: "Activate User",
  },
  {
    label: "Force Cancel",
    value: "Force Cancel",
  },
  {
    label: "Force Settle",
    value: "Force Settle",
  },
  {
    label: "Force Cancel",
    value: "Force Cancel",
  },
  {
    label: "Force Settle",
    value: "Force Settle",
  },
  {
    label: "Udate Operator Tire Config",
    value: "Udate Operator Tire Config",
  },
  {
    label: "Add New Tier",
    value: "Add New Tier",
  },
  {
    label: "Update Tier",
    value: "Update Tier",
  },
  {
    label: "Active Tier",
    value: "Active Tier",
  },
  {
    label: "Inactive Tier",
    value: "Inactive Tier",
  },
  {
    label: "Create Ticket",
    value: "Create Ticket",
  },
  {
    label: "Update Ticket",
    value: "Update Ticket",
  },
  {
    label: "Create Deposit Request",
    value: "Create Deposit Request",
  },
  {
    label: "Reject Deposit",
    value: "Reject Deposit",
  },
  {
    label: "Approve Deposit",
    value: "Approve Deposit",
  },
  {
    label: "Create Withdraw Request",
    value: "Create Withdraw Request",
  },
  {
    label: "Reject Withdraw",
    value: "Reject Withdraw",
  },
  {
    label: "Approve Withdraw",
    value: "Approve Withdraw",
  },
  {
    label: "Approve Topup",
    value: "Approve Topup",
  },
  {
    label: "Reject Topup",
    value: "Reject Topup",
  },
  {
    label: "Approve Payout",
    value: "Approve Payout",
  },
  {
    label: "Save Payment Config",
    value: "Save Payment Config",
  },
  {
    label: "Cancel Payment Config",
    value: "Cancel Payment Config",
  },
  {
    label: "Deposit Power Pay Manual",
    value: "Deposit Power Pay Manual",
  },
  {
    label: "Approve Affiliate Payout",
    value: "Approve Affiliate Payout",
  },
  {
    label: "Reject Affiliate Payout ",
    value: "Reject Affiliate Payout ",
  },
  {
    label: "Refund Affiliate Payout",
    value: "Refund Affiliate Payout",
  },
  {
    label: "Reject with No Refund",
    value: "Reject with No Refund",
  },
  {
    label: "Update Loyalty Config",
    value: "Update Loyalty Config",
  },
  {
    label: "Create Loyalty Category",
    value: "Create Loyalty Category",
  },
  {
    label: "Loyalty Category",
    value: "Loyalty Category",
  },
  {
    label: "Create Loyalty Reward",
    value: "Create Loyalty Reward",
  },
  {
    label: "Update Loyalty Reward",
    value: "Update Loyalty Reward",
  },
  {
    label: "Approve Loyalty Redemption",
    value: "Approve Loyalty Redemption",
  },
  {
    label: "Reject Loyalty Redemption",
    value: "Reject Loyalty Redemption",
  },
  {
    label: "Approve Point Request",
    value: "Approve Point Request",
  },
  {
    label: "Reject Point Request",
    value: "Reject Point Request",
  },
  {
    label: "Create Banner",
    value: "Create Banner",
  },
  {
    label: "Edit Banner",
    value: "Edit Banner",
  },
  {
    label: "Delete Banner",
    value: "Delete Banner",
  },
  {
    label: "Create Event Reward",
    value: "Create Event Reward",
  },
  {
    label: "Update Event Reward",
    value: "Update Event Reward",
  },
  {
    label: "Delete Event Reward",
    value: "Delete Event Reward",
  },
  {
    label: "Create Event",
    value: "Create Event",
  },
  {
    label: "Update Event",
    value: "Update Event",
  },
  {
    label: "Delete Event",
    value: "Delete Event",
  },
  {
    label: "Create Sub Event",
    value: "Create Sub Event",
  },
  {
    label: "Update Sub Event",
    value: "Update Sub Event",
  },
  {
    label: "Delete Sub Event",
    value: "Delete Sub Event",
  },
  {
    label: "Create Blacklisted Users",
    value: "Create Blacklisted Users",
  },
  {
    label: "Delete Blacklisted Users",
    value: "Delete Blacklisted Users",
  },
  {
    label: "Update Payment Account (V2)",
    value: "Update Payment Account (V2)",
  },
  {
    label: "Create Payment Account (V2)",
    value: "Create Payment Account (V2)",
  },
  {
    label: "Create Manual Deposit (V2)",
    value: "Create Manual Deposit (V2)",
  },
  {
    label: "Create Manual Withdraw (V2)",
    value: "Create Manual Withdraw (V2)",
  },
  {
    label: "Approve Manual Withdraw (V2)",
    value: "Approve Manual Withdraw (V2)"
  },
  {
    label: "Approve Manual Deposit (V2)",
    value: "Approve Manual Deposit (V2)"
  },
  {
    label: "Disable Deposit (V2)",
    value: "Disable Deposit (V2)"
  },
  {
    label: "Disable Withdraw (V2)",
    value: "Disable Withdraw (V2)"
  },
  {
    label: "Enable Deposit (V2)",
    value: "Enable Deposit (V2)"
  },
  {
    label: "Enable Withdraw (V2)",
    value: "Enable Withdraw (V2)"
  },
  {
    label: "Reject Manual Deposit (V2)",
    value: "Reject Manual Deposit (V2)"
  },
  {
    label: "Reject Manual Withdraw (V2)",
    value: "Reject Manual Withdraw (V2)"
  },
  {
    label: "Update Tracking Loyalty Redemption",
    value: "Update Tracking Loyalty Redemption"
  },
  {
    label:"Update User Redeem Limit",
    value:"Update User Redeem Limit"
  }
]);

const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});

const selectedAction = ref({
  label: "All",
  value: "",
},);


const onOptionSelected = (e: any) => {
  selectedAction.value = e;
  emit("update:form", { ...props.form, action: e.value });
};




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: _unref(showSync)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        static: "",
        class: "fixed z-10 inset-0 overflow-y-auto",
        onClose: _cache[9] || (_cache[9] = ($event: any) => (showSync.value = false)),
        open: _unref(showSync)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(DialogTitle), {
                        as: "h3",
                        class: "text-lg leading-6 font-medium text-gray-900"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("messages.activityLog.advanceFilter")), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("messages.activityLog.actionTo")), 1),
                        _createElementVNode("div", _hoisted_7, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (((__props.form as any).actionTo) = $event)),
                            name: "actionTo",
                            id: "actionTo",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, (__props.form as any).actionTo]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("messages.activityLog.action")), 1),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(DropdownComponent, {
                            class: "w-full",
                            options: actionList.value,
                            modelValue: selectedAction.value,
                            onOnOptionSelected: onOptionSelected
                          }, null, 8, ["options", "modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("messages.activityLog.actionBy")), 1),
                        _createElementVNode("div", _hoisted_13, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (((__props.form as any).actionBy) = $event)),
                            name: "actionBy",
                            id: "actionBy",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, (__props.form as any).actionBy]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("messages.activityLog.logId")), 1),
                        _createElementVNode("div", _hoisted_16, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (((__props.form as any).logId) = $event)),
                            name: "logId",
                            id: "logId",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, (__props.form as any).logId]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("messages.activityLog.ipAddress")), 1),
                        _createElementVNode("div", _hoisted_19, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (((__props.form as any).ipAddress) = $event)),
                            name: "ipAddress",
                            id: "ipAddress",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, (__props.form as any).ipAddress]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("messages.activityLog.amount")) + " " + _toDisplayString(">="), 1),
                        _createElementVNode("div", _hoisted_22, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (((__props.form as any).amountGte) = $event)),
                            name: "amountGte",
                            id: "amountGte",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, (__props.form as any).amountGte]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("messages.activityLog.amount")) + " " + _toDisplayString("<="), 1),
                        _createElementVNode("div", _hoisted_25, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (((__props.form as any).amountLte) = $event)),
                            name: "amountLte",
                            id: "amountLte",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, (__props.form as any).amountLte]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("messages.activityLog.traceId")), 1),
                        _createElementVNode("div", _hoisted_28, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (((__props.form as any).traceId) = $event)),
                            name: "traceId",
                            id: "traceId",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, (__props.form as any).traceId]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('submit', 1))),
                      class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm"
                    }, _toDisplayString(_ctx.$t("messages.activityLog.filter")), 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('submit'))),
                      class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                    }, _toDisplayString(_ctx.$t("messages.activityLog.cancel")), 1)
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})